import { memo } from "react"
import { useIsCellVisible } from "../../../../../hooks/useTimelineViewport"
import TimelineTween from "./TimelineTween"

type Props = {
    objectId: string
    animationId: string
    TimelineTweenWidth: number
    index: number
    /**
     * Passed down from the parent row, which already holds `object.animations` — looking the
     * animation up here would mean another O(objects x animations) `selectAnimationById` pass.
     */
    delay: number
    duration: number
}

/**
 * TimelineTweenWrapper - renders the tween only while it is horizontally in view.
 */
const TimelineTweenWrapper = ({
    objectId,
    animationId,
    TimelineTweenWidth,
    index,
    delay,
    duration,
}: Props) => {
    // keep in sync with the geometry TimelineTween renders with
    const isInViewport = useIsCellVisible(
        TimelineTweenWidth * delay,
        TimelineTweenWidth * duration - 2
    )

    // nothing at all for off-screen tweens: the placeholder was an invisible <div> that also
    // ran the O(objects x animations) `selectAnimationById` lookup on every render
    if (!isInViewport) return null

    return (
        <TimelineTween
            objectId={objectId}
            animationId={animationId}
            TimelineTweenWidth={TimelineTweenWidth}
            index={index}
        />
    )
}

export default memo(TimelineTweenWrapper)
